let currentSnack = () => { };
export function subscribeSnack(theSnack) {
    currentSnack = theSnack;
}
export function snack(message) {
    currentSnack(message);
}
